/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Contact info
 * @export
 * @interface ContactsInfoModel
 */
export interface ContactsInfoModel {
    /**
     * Phone numbers.
     * @type {Array<string>}
     * @memberof ContactsInfoModel
     */
    phones?: Array<string> | null;
    /**
     * Email addresses.
     * @type {Array<string>}
     * @memberof ContactsInfoModel
     */
    emails?: Array<string> | null;
}

/**
 * Check if a given object implements the ContactsInfoModel interface.
 */
export function instanceOfContactsInfoModel(value: object): value is ContactsInfoModel {
    return true;
}

export function ContactsInfoModelFromJSON(json: any): ContactsInfoModel {
    return ContactsInfoModelFromJSONTyped(json, false);
}

export function ContactsInfoModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactsInfoModel {
    if (json == null) {
        return json;
    }
    return {
        
        'phones': json['phones'] == null ? undefined : json['phones'],
        'emails': json['emails'] == null ? undefined : json['emails'],
    };
}

  export function ContactsInfoModelToJSON(json: any): ContactsInfoModel {
      return ContactsInfoModelToJSONTyped(json, false);
  }

  export function ContactsInfoModelToJSONTyped(value?: ContactsInfoModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'phones': value['phones'],
        'emails': value['emails'],
    };
}

